import notify from '../mixins/Notify';

export function focusInputField(fieldName) {
    if (document.getElementById(fieldName)) {
        document.getElementById(`${fieldName}-input`).focus();
    }
}

export function scrollToElementById(fieldId) {
    if (document.getElementById(fieldId)) {
        document.getElementById(fieldId).scrollIntoView({
            behavior: 'smooth',
        });
    }
}

export function scrollToElementByIdWithOffset(fieldId, offset) {
    const yourElement = document.getElementById(fieldId);
    const yCoordinate = yourElement.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -offset;

    window.scrollTo({
        top: yCoordinate + yOffset,
        behavior: 'smooth',
    });
}

export function scrollToPreviousElement(fieldId) {
    if (document.getElementById(fieldId)) {
        if (document.getElementById(fieldId).previousElementSibling) {
            document.getElementById(fieldId).previousElementSibling.scrollIntoView({
                behavior: 'smooth',
            });
        } else {
            document.getElementById(fieldId).scrollIntoView({
                behavior: 'smooth',
            });
        }
    }
}

export function notifyAllReponseErrors(errorObj) {
    Object.keys(errorObj).forEach((errorKey) => {
        notify.failureNotify(errorKey, errorObj[errorKey]);
    });
}
